import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vs-changelog-mobile',
  templateUrl: './vs-changelog-mobile.component.html',
  styleUrls: [ './vs-changelog-mobile.component.scss' ]
})
export class VsChangelogMobileComponent implements OnInit {

  public mainContent = {};
  public innerContent = {};

  public name = 'ChangeLogListMobileViewComponent';

  constructor() { }

  ngOnInit() {
  }

}
